import * as React from "react";
import {
  Table,
  Header,
  Divider,
  Input,
  Button,
} from "semantic-ui-react";

import UNbd from '../../../components/util/UNbd';
import axios from 'axios'

import 'katex/dist/katex.min.css';

const { InlineMath, BlockMath } = require('react-katex')

interface INbdProps {
  state: any;
}

interface INbdState {
  k: number;
  m: number;
  P0: number;
  is_k_calculated: boolean;
}


class Nbd extends React.Component<INbdProps, INbdState> {

  constructor(props: INbdProps) {
    super(props);
    this.state = {
      k: 0.099,
      m: 0.4125,
      P0: 0.85,
      is_k_calculated: false,
    };

    this.m_handleInput = this.m_handleInput.bind(this);
    this.P0_handleInput = this.P0_handleInput.bind(this);
    this.httpChangeHandler = this.httpChangeHandler.bind(this);

  }

  m_handleInput(event: React.FormEvent<HTMLInputElement>) {
    event.preventDefault();
    this.setState({
      m: Number(event.currentTarget.value),
      is_k_calculated: false,
    })
  }

  P0_handleInput(event: React.FormEvent<HTMLInputElement>) {
    event.preventDefault();
    this.setState({
      P0: Number(event.currentTarget.value),
      is_k_calculated: false,
    })
  }

  httpChangeHandler = () => {
    axios.post('https://app.wayama.io/api/v1/k',
      {
        withCredentials: true,
        m: this.state.m,
        P0: this.state.P0,
        model: "",
        category: "",
      })
      .then(res => {
        console.log("http success")
        console.log(res.status)
        console.log(res.statusText)
        console.log(res.data)
        console.log(res.data.k)

        this.setState({
          k: res.data.k,
          is_k_calculated: true,
        })

      })
      .catch(error => {
        console.log("error : error")
        console.log(error.status)
        console.log(error.statusText)
        console.log(error.data)
      })
  }

  initVariables = () => {
    this.setState({
      k: 0.099,
      m: 0.4125,
      P0: 0.85,
      is_k_calculated: false,
    })
  }

  render() {

    return (
      <div>

        <Header as="h3">負の二項分布</Header>
        <Divider />

        負の二項分布は<a href="https://ja.wayama.io/article/mkt/1/#1-3--negative-binomical-distribution">こちら</a>より、以下の様に表現できます。

        <BlockMath>{`
         P\\left(r \\right) = \\frac{\\left(1 + \\frac{M}{K} \\right)^{-K} \\cdot \\Gamma\\left(K + r \\right)}{\\Gamma\\left(r + 1 \\right)\\cdot \\Gamma\\left(K \\right)} \\cdot \\left(\\frac{M}{M+K} \\right)^r
      `}</BlockMath>

        <h5><InlineMath>{`m`}</InlineMath>と<InlineMath>{`P_0`}</InlineMath>からNBDを求める</h5>
        <div className="nbd_model_selected">
          <Table celled>
            <Table.Header className='model_table_header'>
              <Table.Row>
                <Table.HeaderCell>項目</Table.HeaderCell>
                <Table.HeaderCell>値</Table.HeaderCell>
                <Table.HeaderCell>入力<br />check</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body className='model_tabe_body'>
              <Table.Row>
                <Table.Cell><InlineMath>{`m`}</InlineMath></Table.Cell>
                <Table.Cell>
                  <Input
                    placeholder='0.4125'
                    onChange={this.m_handleInput}
                  />
                </Table.Cell>
                <Table.Cell>
                  {this.state.m}
                </Table.Cell>

              </Table.Row>

              <Table.Row>
                <Table.Cell><InlineMath>{`P_0`}</InlineMath></Table.Cell>
                <Table.Cell>
                  <Input
                    placeholder='0.85'
                    onChange={this.P0_handleInput}
                  />
                </Table.Cell>
                <Table.Cell>
                  {this.state.P0}
                </Table.Cell>
              </Table.Row>

            </Table.Body>
          </Table>
        </div>

        <div className="button_get_nbd">
          <Button
            active
            onClick={this.httpChangeHandler}
          >
            計算実行
          </Button>
          <Button
            active
            onClick={this.initVariables}
          >
            初期化
          </Button>
        </div>


        {this.state.is_k_calculated &&
          <div>
            <Divider />
            <h5>計算結果</h5>
            <div className="nbd_model_selected">
              <Table celled>
                <Table.Header className='model_table_header'>
                  <Table.Row>
                    <Table.HeaderCell>項目</Table.HeaderCell>
                    <Table.HeaderCell>値</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body className='model_tabe_body'>
                  <Table.Row>
                    <Table.Cell><InlineMath>{`m`}</InlineMath></Table.Cell>
                    <Table.Cell>{this.state.m.toFixed(3)}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell><InlineMath>{`k`}</InlineMath></Table.Cell>
                    <Table.Cell>{this.state.k.toFixed(3)}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
          </div>
        }

        {this.state.is_k_calculated &&
          <UNbd
            data={{
              m: this.state.m,
              P0: this.state.P0,
              k: this.state.k,
            }}
          />
        }
      </div>
    );
  }
}

export default Nbd;
